// extracted by mini-css-extract-plugin
export var header = "_ud-1";
export var maskBottom = "_ud-6";
export var maskMiddle = "_ud-7";
export var maskTop = "_ud-5";
export var root = "_ud-0";
export var scrollDownButton = "_ud-3";
export var scrollDownButtonHidden = "_ud-4";
export var viewport = "_ud-2";